export const CONTACT_FIELDS_VERIFIED_ERR_MSG = `If this is the individual you are trying to create, edit the existing individual's record to make applicable changes`;

export const getFieldNameByType = (type) =>
  type === 'email' ? 'email address' : 'phone number';

export const getErrMessageByFirstAndLastName = (
  firstName,
  lastName,
  onNameClick,
  fieldName = 'email address'
) => {
  const fullName = (
    <span
      className="cursor-pointer text-decoration-underline font-weight-bold"
      onClick={() => {
        onNameClick?.();
      }}
    >
      {firstName} {lastName}
    </span>
  );
  return (
    <span>
      This {fieldName} is already associated with {fullName}.{' '}
      {CONTACT_FIELDS_VERIFIED_ERR_MSG}. Otherwise, please enter a different{' '}
      {fieldName}.
    </span>
  );
};
